import React, { useEffect } from 'react';
//import NotFound from "../img/NotFound.svg";
import { useStateValue } from "../context/StateProvider";
import GalleryContainer from "./GalleryContainer";
import { getAllGalleryItems } from "../utils/firebaseFunctions";
import { actionType } from "../context/reducer";

const Galeria = () => {
  const [{ galleryitems }, dispatch] = useStateValue();  

  const fetchData = async () => {
    await getAllGalleryItems().then((data) => {
      dispatch({
        type: actionType.SET_GALLERYITEMS,
        galleryitems: data,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section
    className=""
    id="galeria">
        {/* ml-auto w-auto h-96 */}
        {/* w-full h-full */}
        {/* className="h-340" */}
        {/* <div className="ml-auto w-auto h-96 flex flex-col items-center justify-center gap-6">          
            <img src={NotFound} alt="No Disponible"/>
            <p className="text-xl text-headingColor font-semibold my-2">
                Items no disponibles
            </p>
        </div> */}
        <GalleryContainer
          scrollValue={0}
          flag={false}
          data={galleryitems}
        />
     </section>
  );
};

export default Galeria;